/**
 * Calculate the customer-facing transport charge from a one-way distance.
 *
 * Trainers return to the office after every training day unless accommodation
 * is included, in which case the booking is charged for one return trip.
 */
export const CUSTOMER_TRANSPORT_RATE_PER_KM = 4;

export function calculateCustomerTransportCharge(
  distanceMeters: number | null | undefined,
  durationDays: number,
  accommodationIncluded: boolean,
  ratePerKilometer: number = CUSTOMER_TRANSPORT_RATE_PER_KM
): number {
  const meters = Number(distanceMeters);
  if (!Number.isFinite(meters) || meters <= 0) {
    return 0;
  }

  const days = Math.max(1, Number(durationDays) || 1);
  const returnTrips = accommodationIncluded ? 1 : days;

  const rate = Math.max(0, Number(ratePerKilometer) || 0);

  return (meters / 1000) * 2 * rate * returnTrips;
}
